export default {
  profile: {
    title: "个人中心",
    requiresAuth: true,
    componentPath: "Profile"
  },
  identity: {
    title: "防沉迷认证",
    requiresAuth: true,
    componentPath: "Identity"
  },
  password: {
    title: "修改密码",
    requiresAuth: true,
    componentPath: "Password"
  },
  verifier: {
    title: "安全验证",
    requiresAuth: true,
    componentPath: "Verifier"
  },
  bindPhone: {
    title: "绑定手机",
    requiresAuth: true,
    componentPath: "Phone"
  }
};
